import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const UserMenuItem = ({ id, label, Icon, disabled, onClick }) => {
  return (
    <MenuItem disabled={disabled} id={id} onClick={onClick}>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={label} />
    </MenuItem>
  );
};

UserMenuItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({}),
  ]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

UserMenuItem.defaultProps = {
  Icon: undefined,
  disabled: false,
  onClick: undefined,
};

export default UserMenuItem;
